// Dutch next to English in the demo store's simulated data.
//
// The demo's sample text (Allen's findings, suggestions, notes, …) is written in English
// and keeps that text exactly. withNl() gives an item its Dutch alongside: each listed
// key becomes a getter that answers in the portal's CURRENT language. The language is a
// ref (vue-i18n), so a computed or a template that reads the key re-renders on a switch,
// and the screens that show the data need no change. Store, zone, promo and people
// names are never translated, so they are simply not listed.
//
// A plain copy ({ ...item }) takes the text in the language of that moment; copy with
// copyWithNl() to keep a copy that follows the language.

import { currentLanguage } from '@/i18n'

export function demoIsNl() {
  return currentLanguage() === 'nl'
}

// `nl` maps key -> Dutch text (or any Dutch value). Writing the key sets both languages.
export function withNl(obj, nl) {
  for (const [key, nlValue] of Object.entries(nl || {})) {
    let en = obj[key]
    let du = nlValue
    Object.defineProperty(obj, key, {
      get: () => (demoIsNl() ? du : en),
      set: (v) => { en = v; du = v },
      enumerable: true,
      configurable: true,
    })
  }
  return obj
}

// A copy of `obj` whose language-aware keys stay language-aware, with `en` keys set
// (English) and their Dutch in `nl`.
export function copyWithNl(obj, en, nl) {
  const out = Object.defineProperties({}, Object.getOwnPropertyDescriptors(obj))
  for (const [k, v] of Object.entries(en || {})) {
    Object.defineProperty(out, k, { value: v, writable: true, enumerable: true, configurable: true })
  }
  return withNl(out, nl)
}

// A list of strings (e.g. Ask Allen's chips) that reads in the current language.
export function listWithNl(enList, nlList) {
  const out = [...enList]
  enList.forEach((en, i) => {
    Object.defineProperty(out, i, {
      get: () => (demoIsNl() ? nlList[i] : en),
      enumerable: true,
      configurable: true,
    })
  })
  return out
}
